import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Badge } from "@/components/ui/badge";
import { ArrowRight, Spade, Lock } from "lucide-react";

const Minigames = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-background pb-24">
      <div className="p-4 space-y-4 max-w-screen-xl mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
          {/* Preflop Trainer */}
          <button
            onClick={() => navigate("/minigames/preflop")}
            className="glass hover-lift p-5 text-left group"
          >
            <div className="flex items-start gap-3 mb-3">
              <div className="bg-secondary/20 p-2.5 rounded-xl group-hover:bg-secondary/30 transition-colors shrink-0">
                <Spade className="h-5 w-5 text-secondary" />
              </div>
              <div>
                <h3 className="font-bold text-base">{t("preflop_title")}</h3>
                <Badge variant="outline" className="mt-1 text-[10px]">
                  {t("minigames_daily_challenge")}
                </Badge>
              </div>
            </div>
            <p className="text-sm text-muted-foreground mb-4">
              {t("minigames_preflop_desc")}
            </p>
            <div className="flex items-center gap-2 text-secondary font-semibold text-sm group-hover:gap-3 transition-all">
              {t("minigames_play_now")} <ArrowRight className="h-4 w-4" />
            </div>
          </button>

          {/* Coming soon placeholder */}
          <div className="glass p-5 text-left opacity-50">
            <div className="flex items-start gap-3 mb-3">
              <div className="bg-muted/30 p-2.5 rounded-xl shrink-0">
                <Lock className="h-5 w-5 text-muted-foreground" />
              </div>
              <div>
                <h3 className="font-bold text-base">{t("minigames_pot_odds_title")}</h3>
                <Badge variant="outline" className="mt-1 text-[10px]">
                  {t("learn_coming_soon")}
                </Badge>
              </div>
            </div>
            <p className="text-sm text-muted-foreground">
              {t("minigames_pot_odds_desc")}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Minigames;
